import React from 'react';
import { Platform, View } from 'react-native';
import { Text } from '~/components';

import colors from '~/assets/themes/colors';
import type { SvgProps } from 'react-native-svg';

interface Props {
  icon: React.FC<SvgProps>;
  title: string;
  subtitle?: React.ReactNode;
  description: string | React.ReactNode;
}

const CallCenterCard: React.FC<Props> = ({
  icon: Icon,
  title,
  subtitle,
  description,
}) => {
  return (
    <View
      className={`flex-row px-4 py-6 rounded-lg bg-light-100 shadow mt-6 ${
        Platform.OS === 'android' ? 'shadow-black/40' : ''
      }`}
    >
      <Icon color={colors.primary[600]} />

      <View className="ml-2 flex-1">
        <Text className="text-base text-gray-700">{title}</Text>

        {subtitle}

        {typeof description === 'string' ? (
          <Text className="text-sm text-gray-400">{description}</Text>
        ) : (
          description
        )}
      </View>
    </View>
  );
};

export default CallCenterCard;
